export const experienceData = [
    {
        id: 1,
        company: '',
        jobtitle: 'KCB Group Ltd',
        startYear: '2021',
        endYear: '2022'
    },
    {
        id: 2,
        company: 'Data Analyst',
        jobtitle: 'Cloud Factory Kenya Ltd',
        startYear: 'Currently working with Cloud Factory',
        endYear: 'Kenya'
    },
]